import { configureStore } from '@reduxjs/toolkit'
import { authslice } from './auth/authSlice'
import { leadSlice } from './auth/leadSlice'

// config the store
const store = configureStore({
  reducer: {
    auth: authslice.reducer,
    leads: leadSlice.reducer,
  },
})

// export default the store
export default store

// export the action
export const iconAction = authslice.actions
